module.exports = __webpack_public_path__ + "img/02uni-urushi.78942d97.png";